export const MATERIAU_CODE_ACTION = 'AIDE_MATERIAU'
export const VERRES_CODE_ACTION = 'AIDE_VERRES_SIMPLES_COMPLEXES'
export const TYPE_DEPENSE_PRIX_MOYEN = 'PRIXMOYEN'
export const TYPE_DEPENSE_PRIX_ZERO = 'PRIXZERO'
export const TYPE_DEPENSE_PRIX_PLV = 'PRIXPLV'
export const RESULTS_CODE_TYPE_DEPENSE = [
  TYPE_DEPENSE_PRIX_ZERO,
  TYPE_DEPENSE_PRIX_PLV,
  'PRIXBR',
]
export const TYPE_MOYENNE_NATIONALE = 'Moyenne nationale'
export const DEFAULT_CODE_DPTAM = 'DPTAM'
export const FIRST_STEP_TITLE = 'Beneficiaire'
export const OFFER_ONLY_SANTE = 'APRIL_ASP_ONL'

export const SWITCH = {
  'Non OPTAM': ['Non OPTAM', 'OPTAM'],
  OPTAM: ['Non OPTAM', 'OPTAM'],
  'Offre libre': ['Offre libre', '100% santé'],
  '100% santé': ['Offre libre', '100% santé'],
} as { [key: string]: [string, string] }
